'use client'

import React from 'react'
import Link from 'next/link'
import {
  Icon,
  SidecarLogo,
  IconSize,
  IconButton,
  Menu,
  LinkType,
} from 'sidecar-components'
import { ROUTES } from '@/lib/constants'

const globalNavStyles = `flex justify-between items-center
  color-bgDefaultContainer
  color-borderDefaultDecor max-md:border-b md:border-b
  md:relative md:top-auto md:left-auto md:right-auto
  py-4 md:py-4
  pr-[calc(env(safe-area-inset-right)+theme(space.5))] md:pr-[calc(env(safe-area-inset-right)+theme(space.6))] lg:pr-[calc(env(safe-area-inset-right)+theme(space.8))]
  pl-[calc(env(safe-area-inset-left)+theme(space.5))] md:pl-[calc(env(safe-area-inset-left)+theme(space.6))] lg:pl-[calc(env(safe-area-inset-left)+theme(space.8))]
  print:!border-t-0 print:pb-4 print:hidden`

const logoLinkStyles =
  '[&_svg]:color-logo [&_svg]:hover:color-logo [&_svg]:active:color-logo [&_svg]:focus:color-logo focus:outline focus:outline-offset-4 focus:outline-2 focus:color-outlineEngage-weak-default rounded-md md:mr-6'

/** Public navigation component for unauthenticated pages. */
export function PublicNav() {
  return (
    <header className={globalNavStyles}>
      <Link
        href="/login"
        className={logoLinkStyles}
        data-testid="info_logo"
        aria-label="Home"
      >
        <div className="sr-only">Sidecar Health</div>
        <SidecarLogo className="max-md:hidden" />
        <Icon name="sidecar" size={IconSize.XXL} className="md:hidden" />
      </Link>

      <div className="flex gap-4 items-center">
        <Link href={ROUTES.LOGIN} data-testid="link_login" className="mt-0.5">
          Log in
        </Link>

        {/* Help menu with contact information */}
        <Menu
          trigger={
            <IconButton
              testId="btn_help"
              icon="tooltip"
              id="public-nav-help"
              label="Have Questions?"
              size={IconSize.MD}
            />
          }
          align="end"
          sections={[
            {
              title: 'HAVE QUESTIONS?',
              items: [
                {
                  title: 'brokers@sidecarhealth.com',
                  icon: 'email',
                  path: 'mailto:brokers@sidecarhealth.com',
                  pathType: LinkType.CONTACT,
                  titleClassName: 'color-textOnDefault',
                },
                {
                  title: 'Call us at 855-260-0518',
                  subtitle: 'Mon–Fri: 9am-6pm ET',
                  icon: 'phone',
                  path: 'tel:855-260-0518',
                  pathType: LinkType.CONTACT,
                  titleClassName: 'color-textOnDefault',
                },
              ],
            },
          ]}
        />
      </div>
    </header>
  )
}
